var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-coontainer"},[_c('img',{attrs:{"src":_vm.EMPTY_ICON}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btn",on:{"click":_vm.clickBtn}},[_vm._v("去看看")])])}
var staticRenderFns = []

export { render, staticRenderFns }